import { RemoteAccountService } from '../account/service.ts';
import { RemoteRenderService } from '../renders/service.ts';
import { SyncServiceImpl } from '../sync/service.ts';

/**
 * Phase B: networked implementations. Guest mode is simply "no session": the account service
 * returns no token, sync is stopped and renders ask the user to sign in.
 */
const account = new RemoteAccountService();
const sync = new SyncServiceImpl();
const render = new RemoteRenderService(sync);

export const services = { account, sync, render };
